import React from "react";

import { moneyFormat } from "./format";
import TwoPanels from "./TwoPanels";
import Text from "./Text";
import MoneyTable, { populateKeys } from "./MoneyTable";

const incomeStatementKeys = [
  {
    group: "Gross Profits",
    rows: [
      { label: "Net Revenues" },
      { label: "Cost of Goods Sold", key: "Cost of Sales" },
      { label: "Gross Profit" }
    ]
  },
  {
    group: "Operating Profit",
    rows: [
      { label: "R&D", key: "R&D Costs" },
      { label: "Holding Expenses", key: "Holding Costs" },
      { label: "Promotion", key: "Promotion Costs" },
      { label: "Selling", key: "Selling Costs" },
      {
        label: "Other G&A",
        key: "Other G&A Costs",
        fn: sheet => sheet["Other G&A Costs"] + sheet["Depreciation Expense"],
      },
      {
        label: "Operating Profit",
        fn: sheet => sheet["Gross Profit"] + sheet["Total Operating Costs"]
      }
    ]
  },
  {
    group: "Net Profits",
    rows: [
      { label: "Interest Expense" },
      { label: "Gain or Losses", key: "Gain or Loss of Sales" },
      { label: "Taxes" },
      { label: "Net Profits", key: "Net Income" }
    ]
  }
];

export const IncomeStatementPanel = ({ sheet }) => (
  <MoneyTable keys={populateKeys(incomeStatementKeys, sheet)} />
);

const IncomeStatement = ({ incomeStatement, round, rounds }) => {
  const roundObj = rounds.find(i => Number(i.number) === round);
  const isRoundLive = roundObj ? (
    roundObj.is_started === true
    && roundObj.is_finished === false
    && roundObj.should_be_finished === false
  ) : false;

  const incomeStatementText = isRoundLive
    ? 'This is the current state of your income statement based on product, marketing, operations, and finance expenses. Your revenues and cost of goods sold (i.e. gross profit information) will appear after the round ends.'
    : `Your team generated revenues of${" "}${moneyFormat(incomeStatement["Net Revenues"])} and net profits of${" "}${moneyFormat(incomeStatement["Net Income"])}.`;

  return (
    <TwoPanels title1="Income Statement" title2="Income Statement">
      <Text>
        {incomeStatementText}
      </Text>
      <IncomeStatementPanel sheet={incomeStatement} />
    </TwoPanels>
  );
};

export default IncomeStatement;



// WEBPACK FOOTER //
// ./src/components/analysis/IncomeStatement.js